import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=8ab37614&scoped=true"
import script from "./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=8ab37614&prod&lang=scss&scoped=true"
import style1 from "./AvatarUpload.vue?vue&type=style&index=1&id=8ab37614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab37614",
  null
  
)

export default component.exports